import React from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '../../ui/table';
import { Card, CardContent } from '../../ui/card';
import ArchiveCategoryTableRow, { ArchiveCategory } from './ArchiveCategoryTableRow';

interface ArchiveCategoryTableProps {
  categories: ArchiveCategory[];
  typeColors: Record<string, string>;
  onEdit: (category: ArchiveCategory) => void;
  onDelete: (category: ArchiveCategory) => void;
}

export default function ArchiveCategoryTable({
  categories,
  typeColors,
  onEdit,
  onDelete,
}: ArchiveCategoryTableProps) {
  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Kode</TableHead>
              <TableHead>Nama Kategori</TableHead>
              <TableHead>Tipe</TableHead>
              <TableHead>Modul</TableHead>
              <TableHead className="text-center">Mandatory</TableHead>
              <TableHead className="text-center">Validasi</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Aksi</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {categories.map(cat => (
              <ArchiveCategoryTableRow
                key={cat.id}
                category={cat}
                typeColors={typeColors}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
